// Dashboard
import Dashboard from "../Pages/Dashboard";

// Authentication Pages
import LandingPage from "../Pages/Public/LandingPage";
import ForgetPasswordPage from "../Pages/Authentication/ForgetPassword";
import Logout from "../Pages/Authentication/Logout";
import UserProfile from "../Pages/Settings/UserProfile";

// Utility Pages
import Error404 from "../Pages/Utility/Error404-Page";
import Error500 from "../Pages/Utility/Error500-Page";


// Custom Pages
import Users from "../Pages/Users/Users";
import AddUser from "../Pages/Users/AddUser";
import UserDetails from "../Pages/Users/UserDetails";
import Clients from "../Pages/Clients/Clients";
import Companies from "../Pages/Companies/Companies";
import CompensationValuation from "../Pages/Valuations/CompensationValuation";
import ProjectCategories from "../Pages/Projects/ProjectCategories";
import Projects from "../Pages/Projects/Projects";
import MappedUsersListTables from "../Pages/Projects/MappedUsers";
import Regions from "../Pages/Regions/Regions";
import Crops from "../Pages/Crops/Crops";
import Districts from "../Pages/Districts/Districts";
import Councils from "../Pages/Councils/Councils";
import Wards from "../Pages/Wards/Wards";
import Institutions from "../Pages/Institutions/Institutions";
import ChangePassword from "../Pages/Settings/ChangePassword";
import Roles from "../Pages/Security/Roles/Roles";
import PermissionListTables from '../Pages/Users/Permissions/Permissions';
import MortgageValuationListTables from "../Pages/Valuations/Mortgages/MortgageValuation";
import AssignPermissionsPage from "../Pages/Users/Permissions/AssignPermissionsPage";
import CropCategories from "../Pages/Settings/CropCategories";
import AssetCategories from "../Pages/Settings/AssetCategories";
import CompanyProfile from "../Pages/Settings/CompanyProfile";
import Banks from "../Pages/Settings/Banks";
import AssetValuationListTables from "../Pages/Valuations/Assets/AssetValuation";
import AssetsByCategory from "../Pages/Valuations/Assets/AssetsByCategory";
import Invoices from "../Pages/Payments/Invoices";
import DataReview from "../Pages/Valuations/DataReview";
import DeletedAssets from "../Pages/Valuations/DeletedAssets";
import BarcodeDashboard from "../Pages/Barcodes";
import BarcodeNamingConfig from "../Pages/Barcodes/BarcodeNamingConfig";
import PricingDashboard from "../Pages/Pricing";
import PricingFormulas from "../Pages/PricingFormulas";
import GamisExports from "../Pages/GamisExports";
import AssetImports from "../Pages/AssetImports";
import FinalAssetReports from "../Pages/FinalReports";
import DepartmentManagement from "../Pages/DepartmentManagement";
import ReportSummaryManagement from "../Pages/ReportSummaryManagement";


const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },

  // Security
  { path: "/roles", component: Roles },
  { path: "/roles/:roleId/permissions", component: AssignPermissionsPage },

  // Users
  { path: "/users", component: Users },
  { path: "/add-user", component: AddUser },
  { path: "/update-user/:userId", component: AddUser },
  { path: "/userprofile", component: UserProfile },
  { path: "/company-profile", component: CompanyProfile },
  { path: "/user-info/:userId", component: UserDetails },

    // Crops
    { path: "/crop-categories", component: CropCategories },
    { path: "/asset-categories-setup", component: AssetCategories },
    { path: "/banks", component: Banks },

  // Companies & Clients
  { path: "/companies", component: Companies },
  { path: "/clients", component: Clients },

  // Valuation
  { path: "/assets-valuation", component: AssetValuationListTables },
  { path: "/assets-by-category", component: AssetsByCategory },
  { path: "/pahs", component: CompensationValuation },
  { path: "/mortgages-valuation", component: MortgageValuationListTables },
  { path: "/data-review", component: DataReview },
  { path: "/deleted-assets", component: DeletedAssets },
  { path: "/invoices", component: Invoices },
  { path: "/barcodes", component: BarcodeDashboard },
  { path: "/barcode-naming-config", component: BarcodeNamingConfig },
  { path: "/asset-pricing", component: PricingDashboard },
  { path: "/gamis-exports", component: GamisExports },
  { path: "/asset-imports", component: AssetImports },
  { path: "/final-reports", component: FinalAssetReports },
  { path: "/report-summary-management", component: ReportSummaryManagement },
  { path: "/department-management", component: DepartmentManagement },
  { path: "/asset-pricing-formulas", component: PricingFormulas },

  // Projects
  { path: "/projects", component: Projects },
  { path: "/project-categories", component: ProjectCategories },
  { path: "/mapped-users", component: MappedUsersListTables },

  // Permissions
  { path: "/permissions", component: PermissionListTables },


  // Password
  { path: "/change-password", component: ChangePassword },

  // Setup
  { path: "/crops-setup", component: Crops },
  { path: "/regions-setup", component: Regions },
  { path: "/districts-setup", component: Districts },
  { path: "/councils-setup", component: Councils },
  { path: "/wards-setup", component: Wards },
  { path: "/institutions-setup", component: Institutions },
];

const publicRoutes = [
  { path: "/", component: LandingPage },
  { path: "/logout", component: Logout },
  { path: "/login", component: LandingPage },
  { path: "/forgot-password", component: ForgetPasswordPage },

  // Errors
  { path: "/pages-404", component: Error404 },
  { path: "/pages-500", component: Error500 },
];

export { authProtectedRoutes, publicRoutes };
